module.exports = __webpack_public_path__ + "img/superb.21d0df2b.svg";